/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { Select } from '@qality/common-components/src/molecules/SelectAsync';
import { ISSUE_TYPE } from '@qality/common-config';
import { SelectedIssue } from '@qality/common-model';
import { useTestTypesContext } from '@qality/common-pages';
import { IssueTestTypeDetails } from '@qality/common-pages/src/IssueView/IssueTestTypeProvider/IssueTestTypeProvider';
import {
  IssueService,
  StorageOfUniqueServices,
  TestCasesService,
} from '@qality/common-service';
import MapperService from '@qality/common-service/src/MapperService';

type Props = {
  handleSelectChange: (selectedIssuesIds: Array<string>) => void;
  projectKey?: string;
};

export const AddTestCaseDropdown = ({
  handleSelectChange,
  projectKey,
}: Props): JSX.Element => {
  const [issueTestTypes, setIssueTestTypes] = useState<
    Array<IssueTestTypeDetails>
  >([]);
  const { testTypes, isLoading } = useTestTypesContext();

  const getBrowseIssueUrl =
    StorageOfUniqueServices.get('URLService').getIssueURL;

  const handleChange = (selectedIssues: Array<SelectedIssue>): void => {
    handleSelectChange(selectedIssues.map((i) => i.issueId));
  };

  // dead function? it never returns anything, handleSearchOptions even on load returns values
  const handleLoadOptions = async (
    issueIds: Array<string>
  ): Promise<Array<SelectedIssue>> => {
    const issues = await StorageOfUniqueServices.get(
      'JQLSearchService'
    ).bulkFetchIssuesByIds({
      ids: issueIds,
      fields: ['summary', 'issuetype', 'created', 'status'],
      maxResults: 50,
    });

    return issues.map((issue) =>
      MapperService.formatJIRAIssueToIssue(issue, getBrowseIssueUrl)
    );
  };

  const handleSearchOptions = async (
    query: string,
    alreadyLinkedIssues: Array<number>
  ): Promise<Array<SelectedIssue>> => {
    const response = await IssueService.searchIssuesByQuery(
      query,
      projectKey,
      alreadyLinkedIssues,
      ISSUE_TYPE.QALITY_TEST
    );

    const mappedIssues =
      response?.issues.map((issue) =>
        MapperService.formatJIRAIssueToIssue(issue, getBrowseIssueUrl)
      ) || [];
    if (
      mappedIssues.length > 0 &&
      StorageOfUniqueServices.get('LicenseService').isAdvanced
    ) {
      fetchTestTypesForIssues(mappedIssues.map((i) => i.issueId));
    }

    return mappedIssues;
  };

  const fetchTestTypesForIssues = async (issueIds: number[]): Promise<void> => {
    let issueTestTypesList = [];

    try {
      issueTestTypesList = await TestCasesService.getIssueTestTypes(issueIds);
    } catch (error) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        error,
        'We could not retrieve test types.'
      );
      issueTestTypesList = [];
    }

    setIssueTestTypes((oldValues) => [...oldValues, ...issueTestTypesList]);
  };

  if (isLoading) {
    return <div></div>;
  }

  return (
    <Select
      loadSearchOptions={handleSearchOptions}
      loadOptions={handleLoadOptions}
      onChange={handleChange}
      value={[]}
      issueTestTypes={issueTestTypes}
      testTypes={testTypes}
    />
  );
};
